import { connect } from 'react-redux';
import Error401 from './401';

const mapStateToProps = ({ layout }) => ({
    locale: layout.locale,
});

export default connect(mapStateToProps, null)(Error401);
